import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useCallback } from 'react';
import { createTransformer } from '../core';
var createBreadcrumbSentryContext = function createBreadcrumbSentryContext(breadcrumbs) {
  var breadcrumbContext = {};
  var _iterator = _createForOfIteratorHelper(breadcrumbs),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var breadcrumb = _step.value;
      // TODO: Should avoid conflicts
      breadcrumbContext[breadcrumb.name.toString()] = breadcrumb;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return breadcrumbContext;
};
/**
 * Creates a copy of original the sentry exception payload but
 * enhanced with extra information like source and telemetry breadcrumbs
 */
export var withSentryExceptionTelemetryInformation = function withSentryExceptionTelemetryInformation(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    _ref$payload = _ref.payload,
    exception = _ref$payload.exception,
    hint = _ref$payload.hint,
    scopeContext = _ref$payload.scopeContext;
  var errorThatRevealsDispatchStackTrace = new Error();
  var sentryPayload = {
    exception: exception,
    hint: _objectSpread({
      syntheticException: errorThatRevealsDispatchStackTrace
    }, hint),
    scopeContext: _objectSpread(_objectSpread({}, scopeContext), {}, {
      contexts: _objectSpread(_objectSpread({}, scopeContext === null || scopeContext === void 0 ? void 0 : scopeContext.contexts), {}, {
        telemetryBreadcrumbs: createBreadcrumbSentryContext(breadcrumbs)
      })
    })
  };
  return sentryPayload;
};
export var arbitraryValueToSentryException = function arbitraryValueToSentryException(_ref2) {
  var _ref2$breadcrumbedPay = _ref2.breadcrumbedPayload,
    breadcrumbs = _ref2$breadcrumbedPay.breadcrumbs,
    payload = _ref2$breadcrumbedPay.payload;
  return withSentryExceptionTelemetryInformation({
    breadcrumbs: breadcrumbs,
    payload: {
      exception: payload
    }
  });
};
export var createSentryExceptionEventTransformer = function createSentryExceptionEventTransformer(_ref3) {
  var from = _ref3.from,
    to = _ref3.to,
    useTransformer = _ref3.useTransformer;
  // Gotta be outside the scope otherwise hooks will keep recomputing
  var useSentryTransformer = function useSentryTransformer(transformProps) {
    var transform = useTransformer(transformProps);
    return useCallback(function (_ref4) {
      var breadcrumbs = _ref4.breadcrumbs,
        originalPayload = _ref4.payload;
      var sentryPayload = transform(originalPayload);
      return withSentryExceptionTelemetryInformation({
        payload: sentryPayload,
        breadcrumbs: breadcrumbs
      });
    }, [transform]);
  };
  var ArbitraryEventToConnectedEvent = createTransformer({
    from: from,
    to: to,
    useTransformer: useSentryTransformer
  });
  return ArbitraryEventToConnectedEvent;
};

/**
 * This will create a bridge that listens to arbitrary objects
 * and uploads them as exceptions in Sentry
 */
export var createSentryExceptionEventTransformerFromArbitraryObject = function createSentryExceptionEventTransformerFromArbitraryObject(_ref5) {
  var from = _ref5.from,
    to = _ref5.to;
  return createTransformer({
    from: from,
    to: to,
    useTransformer: function useTransformer() {
      return useCallback(function (breadcrumbedPayload) {
        return arbitraryValueToSentryException({
          breadcrumbedPayload: breadcrumbedPayload
        });
      }, []);
    }
  });
};